import { render } from "./DoctorDialog.vue?vue&type=template&id=51adaf08"
import script from "./DoctorDialog.vue?vue&type=script&lang=js"
export * from "./DoctorDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__